<link href="https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css" rel="stylesheet">

<body class="ltr main-body leftmenu">
    <form autocomplete="off" novalidate>
        <div class="main-content side-content pt-0 ml-0">
            <div class="main-container container-fluid">
                <div class="inner-body">
                    <div class="row row-sm add-form">
                        <form autocomplete="off" class="p-0" novalidate [formGroup]="examformreport">
                            <div class="col-lg-12 col-md-12">
                                <div class="card custom-card">
                                    <div class="card-body">
                                        <div class=" d-flex align-items-center pl-3">
                                            <img alt="Logo" src="../../assets/img/CollegeMaster.png"
                                                class="mh-45px pb-2">
                                            <div class="ml-2">
                                                <h3 class="main-content-label mb-1"><b>
                                                         Exam Form Scrutiny
                                                    </b></h3>
                                                <p class="text-muted card-sub-title mb-0">
                                                    Student's Exam Form</p>
                                            </div>
                                        </div>

                                        <hr class="mt-1 mb-2">
                                        <div class="row clearfix mt-2">
                                            <div class="col-sm-3" *ngIf="isAdminView">
  <mat-form-field appearance="outline" class="example-full-width">
    <mat-label>Status</mat-label>
    <mat-select [(value)]="selectedStatus"
                >
      <mat-option *ngFor="let s of statusList" [value]="s.value">
        {{ s.label }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

                                            <div class="col-sm-3">
                                                <div class="form-group">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>Session</mat-label>
                                                        <mat-select #select232 placeholder="Session" class="colorblack"
                                                            formControlName="SessionId">
                                                            <mat-select-filter *ngIf="select232.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'SnName'"
                                                                [array]="sessionList"
                                                                (filteredReturn)="SessionFilterList =$event"></mat-select-filter>
                                                            <mat-option *ngFor="let item of SessionFilterList"
                                                                [value]="item.SnNo">
                                                                {{item.SnName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                            <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            College
                                                        </mat-label>
                                                        <mat-select #select23
                                                            formControlName="college" [displayMember]="'CgName'">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CgName'"
                                                                [array]="collegeList"
                                                                (filteredReturn)="filteredListCollege =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCollege"
                                                                [value]="item.CgCode" (click)="getCourse(item.CgCode)">
                                                                {{ item | displayValue:'CgCode':'CgName' }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div> 
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                            Course
                                                        </mat-label>
                                                        <mat-select #select55 class="colorblack"
                                                            formControlName="course" (selectionChange)="onCourseChange($event.value)">
                                                            <mat-select-filter *ngIf="select55.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'CoName'"
                                                                [array]="CourseList"
                                                                (filteredReturn)="filteredListCourse =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListCourse"
                                                                [value]="item.CoCode"
                                                                 >
                                                                {{ item | displayValue:'CoCode':'CoName' }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div class="col-sm-2">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                           Exam
                                                        </mat-label>
                                                        <mat-select #select2333 placeholder="CoCode"
                                                            formControlName="EmId">
                                                            <mat-select-filter *ngIf="select2333.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="filteredListExamSch"
                                                                (filteredReturn)="filteredListExamSch =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListExamSch"
                                                                [value]="item.EmId">
                                                                {{ item | displayValue:'EmCoCode':'EmName' }}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-2" *ngIf="Branch">
                                            <div class="form-group">
                                                <div class="">
                                                    <mat-form-field appearance="outline" class="example-full-width">
                                                        <mat-label>
                                                           Branch
                                                        </mat-label>
                                                        <mat-select #select23 placeholder="CoCode"
                                                            formControlName="Branch">
                                                            <mat-select-filter *ngIf="select23.focused"
                                                                [placeholder]="'Filter'" [displayMember]="'EmName'"
                                                                [array]="BranchList"
                                                                (filteredReturn)="filteredListBranch =$event">
                                                            </mat-select-filter>
                                                            <mat-option *ngFor="let item of filteredListBranch"
                                                                [value]="item.StrId">
                                                                {{item.StrName}}
                                                            </mat-option>
                                                        </mat-select>
                                                    </mat-form-field>
                                                </div>
                                            </div>
                                        </div>
                                            
</div>
                                            <div class="row col-sm-12">
                                                <div class="col-sm-12 prpl">
                                                    <button type="button" (click)="back()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="20vh" src="../../assets/img/refresh.gif">
                                                            Reset
                                                        </span>
                                                    </button>


                                                    <button type="button" (click)="getdata()"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/img/list.gif"
                                                                style="margin-right: 7px;">
                                                            List
                                                        </span>
                                                    </button>

                                                    <button type="button" *ngIf="table" (click)="download($event)"
                                                        class="btn size1 btn-primary btn-icon-text floatright mr-3 mt-1">
                                                        <span style="display: contents; align-items: center;">
                                                            <img width="15vh" src="../../assets/images/arrow (1).png"
                                                                style="margin-right: 7px;">
                                                            Download
                                                        </span>
                                                    </button>


                                                </div>
                                            </div>
                                       
                                        <hr class="mt-3">
                                          <!-- <div class="row" *ngIf="table">
                                            <div class="col-sm-6">
                                                <b> Total Count : {{count}}</b>
                                            </div>
                                        </div> -->
                                        <div class="col-sm-12 pl-0">
                                            <div *ngIf="table && !isAdminView">
                                                <div class="table-responsive table-container" id="table">
                                                    <table class="table table-bordered text-nowrap">
                                                        <thead>
                                                            <tr class="text-left">
                                                                <th class="f600">College Code</th>
                                                                <th class="f600">College Name</th>
                                                                <th class="f600">Total Students</th>
                                                                <th class="f600">Students Full Name</th>
                                                                <th class="f600">Father Name</th>
                                                                <th class="f600">Mother Name</th>
                                                                <th class="f600">Mobile NO</th>
                                                                <th class="f600">Email Id</th>
                                                                <th class="f600">Gender</th>
                                                                <th class="f600">Registration No</th>
                                                                <th class="f600">Course</th>
                                                                <th class="f600">Branch</th>
                                                                <th class="f600">Subjects</th>
<th class="f600 text-center">Action</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody class="curs">
                                                            <ng-container *ngFor="let item of allClgCountdatalist">
                                                                <ng-container *ngIf="formatStudents(item.StudentsName).length > 0">
                                                                    <ng-container *ngFor="let studentName of formatStudents(item.StudentsName); let i = index">
                                                                        <tr>
                                                                            <td *ngIf="i === 0" [attr.rowspan]="formatStudents(item.StudentsName).length">
                                                                                {{ item.CgCode }}
                                                                            </td>
                                                                            <td *ngIf="i === 0" [attr.rowspan]="formatStudents(item.StudentsName).length">
                                                                                {{ item.CollegeName }}
                                                                            </td>
                                                                            <td *ngIf="i === 0" [attr.rowspan]="formatStudents(item.StudentsName).length">
                                                                                {{ item.TotalStudents }}
                                                                            </td>
                                                                            <td>{{ studentName }}</td>
                                                                            <td>{{ getArrayField(item.StudentsMidName, i) }}</td>
                                                                            <td>{{ getArrayField(item.StudentsMothName, i) }}</td>
                                                                            <td>{{ getArrayField(item.StuMobile, i) }}</td>
                                                                            <td>{{ getArrayField(item.StuEmailId, i) }}</td>
                                                                            <td>{{ getArrayField(item.StuGender, i) }}</td>
                                                                            <td>{{ getArrayField(item.RegistrationNumber, i) }}</td>
                                                                            <td *ngIf="i === 0" [attr.rowspan]="formatStudents(item.StudentsName).length">
                                                                                {{ item.Course }}
                                                                            </td>
                                                                            <td *ngIf="i === 0" [attr.rowspan]="formatStudents(item.StudentsName).length">
                                                                                {{ item.Branch }}
                                                                            </td>
                                                                            <td>
                                                                                <ng-container *ngFor="let subject of getSubjectsForStudent(item.SubjectsPerStudent, i)">
                                                                                    {{ subject.SubCode }} <br />
                                                                                </ng-container>
<td class="text-center">
  <ng-container *ngIf="item.isLocked">
    <button class="btn btn-success btn-sm" *ngIf="getArrayField(item.ApprovalStatus, i) === 'Y'" disabled>
      Approved
    </button>
    <button class="btn btn-danger btn-sm" *ngIf="getArrayField(item.ApprovalStatus, i) === 'N'" disabled>
      Rejected
    </button>
  </ng-container>
  <ng-container *ngIf="!item.isLocked">

    <button class="btn btn-success btn-sm" (click)="approveForm(item, i)">
    {{getArrayField(item.ApprovalStatus, i) === 'Y' ? 'Approved' : 'Approve'}}
    </button>

    <button class="btn btn-danger btn-sm ms-2" (click)="rejectForm(item, i)">
      {{getArrayField(item.ApprovalStatus, i) === 'N' ? 'Rejected' : 'Reject'}}
    </button>
  </ng-container>
</td>   

                                         </ng-container>
                                                                </ng-container>
                                                            </ng-container>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <div *ngIf="table && isAdminView && selectedStatus">
  <table class="table table-bordered text-nowrap">
    <thead>
      <tr>
        <th>Student Name</th>
        <th>College</th>
        <th>Course</th>
        <th>Registration No</th>
        <th>Mobile No</th>
        <th>Status</th>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let s of filteredAdminData">
        <td>{{ s.studentName }}</td>
        <td>{{ s.college }}</td>
        <td>{{ s.course }}</td>
        <td>{{ s.registrationNo }}</td>
        <td>{{ s.mobile }}</td>
        <td>
          {{ s.status === 'Y' ? 'Approved' :
             s.status === 'N' ? 'Rejected' : 'Pending' }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </form>
</body>